
import Api from '@/utils/api';
import dayjs from 'dayjs';
import XInput from 'vux/src/components/x-input/index.vue'
import Group from 'vux/src/components/group/index.vue'
import XButton from 'vux/src/components/x-button/index.vue'
import Cell from 'vux/src/components/cell/index.vue'
import Scroller from 'vux/src/components/scroller/index.vue'

export default {
data() {
return {
couponType: null,
couponTypeCollected: 0,
recommendProducts: [],
scrollH: "300px",
listIndex: "-1",
isMoreList: false,
loadText: '正在加载',
btnLabel: '立即领取',
code: ''
}
},
components: {
Scroller,
XInput,
Group,
XButton,
Cell
},
computed: {
invalidCoupon() {
if (this.couponType.order) {
return true
} else if (dayjs().isAfter(dayjs(this.couponType.expirationDate).endOf('day'))) {
return true
} else {
return false
}
},
couponBtnText() {
if (this.couponType.order) {
return '已使用'
} else if (dayjs().isAfter(dayjs(this.couponType.expirationDate).endOf('day'))) {
return '已过期'
} else {
return '可使用'
}
}
},
mounted() {
if (!this.$store.state.userInfo.mobileNumber) {
this.$router.push({
name: 'bindMobileNumber',
params: {
ref: 'coupon'
}
})
this.$vux.toast.text('领取兑换码需要先绑定你的手机号')
}
this.getCoupon()

Api.getProductList({limit: 10})
.then(res => {
this.recommendProducts = res.data
})
},
methods: {

async getCoupon(){
try {
const resp = await Api.getCoupon({
id: this.$route.params.id
})
if (resp && resp.data) {
this.couponType = resp.data
} else {
throw Error()
}
} catch (e) {
console.log(e)
this.$vux.alert.show({
title: '失败',
content: '无效的优惠券'
})

}
},
toDetail(id) {
this.$router.push({
name: 'detail',
params: {
id: id
}
});
},
onScrollBtm() {
if(this.isMoreList){
this.isMoreList = false
this.pagination.page ++
}
},
addCart(item_id, sku_id, className, url) {
let imgBox = document.querySelector(`.${className}`);
let relative = imgBox.getBoundingClientRect();

this.$store.commit('updateClassifyAnimate', {
x: relative.left,
y: relative.top,
headPic: url,
item_id: item_id,
sku_id: sku_id,
random: Math.random() * 10000
});

},
}
}



// WEBPACK FOOTER //
// ./src/components/UserCenter/couponList/coupon.vue